import { Pipe, PipeTransform } from '@angular/core';
import { ServiceFeatures } from '../models/serviceFeatures';
import { SessionService } from '../services/session.service';

@Pipe({
    name: 'hasFeature',
    standalone: true
})
export class HasFeaturePipe implements PipeTransform {

	constructor(private sessionService: SessionService) {}

	transform(feature: ServiceFeatures): boolean {
		return this.sessionService.hasFeature(feature);
	}
}
